export default __webpack_public_path__ + "static/media/handwave-1.437c9666.svg";